import ApiService from '@/services/apiService';

export default {
  // **********************************************************
  //
  // INDUSTRY: FACILITY MANAGEMENT (IS-FM): Key Access
  //
  // **********************************************************
  isFmAccessFetch() {
    return ApiService.instance.get('/isfmAccessMgmt').then((response) => {
      return response.data;
    });
  },

  isFmAccessFetchByUserId(id) {
    return ApiService.instance.get(`/isfmAccessMgmt/user/${id}`).then((response) => {
      return response.data;
    });
  },

  isFmAccessGet(context, id) {
    return ApiService.instance.get(`/isfmAccessMgmt/${id}`).then((response) => {
      return response.data;
    });
  },

  isFmAccessCreate(data) {
    return ApiService.instance.post('/isfmAccessMgmt', data);
  },

  isFmAccessActivateLock(data) {
    return ApiService.instance.post('/isfmAccessMgmt/activateLock', data);
  },

  isFmAccessUpdate(data) {
    return ApiService.instance.put(`/isfmAccessMgmt/${data.id}`, data);
  },

  isFmAccessDelete(id) {
    return ApiService.instance.delete(`/isfmAccessMgmt/${id}`);
  },

  // **********************************************************
  //
  // INDUSTRY: FACILITY MANAGEMENT (IS-FM): Ticketing/Maintenance
  //
  // **********************************************************
  isFmTicketsFetch(context, scopeIds) {
    return ApiService.instance
      .get('/isFmTicket', {
        params: { scopeIds: JSON.stringify(scopeIds) },
      })
      .then((response) => {
        return response.data;
      });
  },
  isFmTicketsCount(context, scopeIds, states) {
    return ApiService.instance
      .get('/isFmTicket/count/', {
        params: { scopeIds: JSON.stringify(scopeIds), states: JSON.stringify(states) },
      })
      .then((response) => {
        return response.data;
      });
  },
  // fetch Dtwin tickets that the user is added as contact
  isFmTicketsFetchByUser(id) {
    return ApiService.instance.get(`/isFmTicket/user/${id}`).then((response) => {
      return response.data;
    });
  },

  isFmTicketCreate(context, data) {
    return ApiService.instance.post('/isFmTicket', data);
  },

  isFmTicketUpdate(data) {
    return ApiService.instance.put(`/isFmTicket/${data.id}`, data);
  },

  isFmTicketDelete(id) {
    return ApiService.instance.delete(`/isFmTicket/${id}`);
  },
};
